import { render } from "./FormRadioGroup.vue?vue&type=template&id=10cad39a"
import script from "./FormRadioGroup.vue?vue&type=script&lang=js"
export * from "./FormRadioGroup.vue?vue&type=script&lang=js"

import "./FormRadioGroup.vue?vue&type=style&index=0&id=10cad39a&lang=scss"
script.render = render

export default script